import { FC } from 'react';

import { MetamaskRound } from '@uikit/icons/Metamask';
import { PasskeysRound } from '@uikit/icons/PassKeys';
import { TonBrandColor } from '@uikit/icons/TonBrandColor';

export enum WalletConnectType {
  PASSKEY = 'Passkey',
  EVM = 'EVM',
  TON = 'TON',
}

export const WALLET_CONNECT_TYPES = [
  WalletConnectType.PASSKEY,
  WalletConnectType.EVM,
  WalletConnectType.TON,
];

type WalletsConfig = Record<
  WalletConnectType,
  {
    Icon: FC;
    label: string;
    connectButtonText: string;
  }
>;

export const WALLETS_CONFIG: WalletsConfig = {
  EVM: {
    Icon: () => <MetamaskRound className="icon" />,
    label: 'EVM Wallet',
    connectButtonText: 'Connect',
  },
  Passkey: {
    Icon: () => <PasskeysRound className="icon" />,
    label: 'Passkeys Wallet',
    connectButtonText: 'Create',
  },
  TON: {
    Icon: () => <TonBrandColor className="icon" />,
    label: 'Ton Wallet',
    connectButtonText: 'Connect',
  },
};
